<div class="table-wrapper">
  <div class="actions">
    <ct-lib-table-search-input
      [placeholder]="'jobboard.platform.profile.sections.languages.search-placeholder'"
      (search)="onSearch($event)"
    />
    <app-button htmlType="button" [iconStart]="icons.plus" (click)="openAddModal()">
      {{ 'jobboard.platform.profile.sections.languages.add' | transloco }}
    </app-button>
  </div>

  @if (languages().length === 0) {
    <ct-lib-empty-placeholder
      [icon]="icons.empty"
      [title]="'jobboard.platform.profile.sections.languages.empty' | transloco"
      text=""
    />
  } @else if (visibleLanguages().length === 0) {
    <ct-lib-empty-placeholder
      [icon]="icons.empty"
      [title]="'jobboard.platform.profile.sections.languages.search-empty' | transloco"
      text=""
    />
  } @else {
    <p-table
      [value]="visibleLanguages()"
      dataKey="code"
      [rowTrackBy]="trackByLanguage"
      sortField="code"
      [sortOrder]="1"
      [scrollable]="true"
      scrollHeight="40rem"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="code" class="name-col">
            {{ 'jobboard.platform.profile.sections.languages.table.name' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th pSortableColumn="level">
            {{ 'jobboard.platform.profile.sections.languages.table.level' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="actions">
            {{ 'jobboard.platform.profile.sections.languages.table.actions' | transloco }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-language>
        <tr>
          <td>
            <span class="language-name">{{ languageDisplayName(language.code) }}</span>
          </td>
          <td>
            <ct-lib-skill-level-tag
              [levelLabel]="languageLevelLabel(language.level)"
              [options]="languageLevelOptions"
              [selectedValue]="language.level"
              [deletable]="false"
              (levelChange)="updateLanguageLevel(language.code, $event)"
            />
          </td>
          <td class="actions">
            <fa-icon
              [icon]="icons.trash"
              size="lg"
              class="red"
              [tooltip]="'jobboard.platform.profile.sections.languages.remove' | transloco"
              [attr.aria-label]="'jobboard.platform.profile.sections.languages.remove' | transloco"
              (click)="removeLanguage(language.code)"
            ></fa-icon>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<ct-lib-modal
  #addModal
  [small]="true"
  [label]="'jobboard.platform.profile.sections.languages.modal.title' | transloco"
  [footer]="addFooter"
>
  <div class="add-language-form">
    <div class="form-group form-floating">
      <ng-select
        class="form-control"
        [formControl]="newLanguageCode"
        appendTo="body"
        [placeholder]="'jobboard.platform.profile.sections.languages.name' | transloco"
        id="profileLanguageCode"
      >
        @for (language of languageOptions(); track language.code) {
          <ng-option [value]="language.code">
            {{
              languageService.currentLanguage?.value === 'de-DE'
                ? language.germanName
                : language.name
            }}
          </ng-option>
        }
      </ng-select>
      <label for="profileLanguageCode">{{
        'jobboard.platform.profile.sections.languages.name' | transloco
      }}</label>
    </div>
    <div class="form-group form-floating">
      <ng-select
        class="form-control"
        [formControl]="newLanguageLevel"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
        id="profileLanguageLevel"
      >
        @for (option of languageLevelOptions; track option.value) {
          <ng-option [value]="option.value">{{ option.label | transloco }}</ng-option>
        }
      </ng-select>
      <label for="profileLanguageLevel">{{
        'jobboard.platform.profile.sections.languages.level' | transloco
      }}</label>
    </div>
  </div>
</ct-lib-modal>

<ng-template #addFooter>
  <button type="button" class="ct-btn ct-btn-white-grey" (click)="closeAddModal()">
    {{ 'jobboard.platform.profile.sections.languages.modal.cancel' | transloco }}
  </button>
  <button
    type="button"
    class="ct-btn ct-btn-primary"
    [disabled]="!(newLanguageCode.value ?? '').toString().trim()"
    (click)="submitAddLanguage()"
  >
    {{ 'jobboard.platform.profile.sections.languages.modal.submit' | transloco }}
  </button>
</ng-template>
